import serverCall from "../serverCall";

const getProfile = () => {
  try {
    const response = serverCall.get(`/users/user-profile`);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateProfile = (body) => {
  try {
    const response = serverCall.put(`/users/update-profile`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const ProfileService = {
  getProfile,
  updateProfile,
};

export default ProfileService;
